<div class="row">
  <div class="col-12">
    <h3 class="mt-3" id="propertiesTransferred">Informations sur les colonies de vacance</h3>

    @for (campForm of this.camps.formGroups; track campForm; let i = $index) {
      <div class="card">
        <div class="row card-body">
          <div class="row d-flex justify-content-between">
            <div class="d-flex" style="width: fit-content">
              <h3 [id]="'colonie-vacances-' + (i+1)">Colonie de vacance #{{ i + 1 }}</h3>
            </div>
            <div class="dropdown d-flex" style="width: fit-content">
              <a aria-haspopup="true" class="dropdown-ellipses dropdown-toggle" data-bs-toggle="dropdown"
                data-expanded="false" href="#" role="button">
                <i class="fe fe-more-vertical"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <a (click)="removeCamp(i); $event.preventDefault()" class="dropdown-item"
                  href="#">
                  Supprimer
                </a>
              </div>
            </div>
          </div>
          <app-rrsp-personal-tax-child-camp-form #property [campForm]="campForm" [form]="this.form"
          [index]="i"></app-rrsp-personal-tax-child-camp-form>
        </div>
      </div>
    }

    <div class="card">
      <a (click)="this.addCamp(); $event.preventDefault()" class="card-body" href="#propertiesTransferred"
        id="add_property_transferred">
        + Ajouter une colonie de vacances
      </a>
    </div>

  </div>
</div>